export const theme = {
    primaryDark: '#292b2c',
    primaryLight: '#f7f7f7 ',
    primaryHover: '#343078',
    mobile: '576px',
  }